<template>
    <tr
        v-if="item"
        class="session__show_people_table_item"
    >
        <td class="session__show_people_table_item_name">{{ userFirstName }} {{ userLastName }}</td>
        <td class="session__show_people_table_item_email"><a :href="`mailto:${userEmail}`">{{ userEmail }}</a></td>
        <td class="session__show_people_table_item_status">
            <component-status :status="userBookingStatus"/>
        </td>
        <td class="session__show_people_table_item_actions">
            <div class="columns is-vcentered is-variable is-2">
                <template v-if="userBookingForm.length">
                    <div class="column is-narrow">
                        <component-button
                            :border="true"
                            :theme="'primary'"
                            :name="'session-show-people-table-item-actions-view'"
                            @click="emitViewBookingForm"
                        >{{ $t('ebs.sessions.show.buttons.viewBookingForm') }}
                        </component-button>
                    </div>
                </template>
                <template v-if="userBookingStatus === 'on-waitlist' && (user.isEventCoordinator() || user.isSessionTrainer(sessionTrainers)) && false">
                    <div class="column is-narrow">
                        <component-button
                            class="btn--remove"
                            :border="true"
                            :theme="'secondary'"
                            :name="`session-show-people-table-item-actions-remove-${userSubscriptionId}`"
                            @click="performEmit('emit-remove-from-waitlist', userSubscriptionId)"
                        >{{ $t('ebs.sessions.show.buttons.remove') }}</component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            class="btn--invite"
                            :border="true"
                            :theme="'tertiary'"
                            @click="performEmit('emit-invite-person', userSubscriptionId)"
                            :name="`session-show-people-table-item-actions-invite-${userSubscriptionId}`"
                        >{{ $t('ebs.sessions.show.buttons.invite') }}</component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            class="btn--book"
                            :theme="'primary'"
                            :name="`session-show-people-table-item-actions-book-${userSubscriptionId}`"
                            @click="performEmit('emit-book-person', userSubscriptionId)"
                        >{{ $t('ebs.sessions.show.buttons.book') }}</component-button>
                    </div>
                </template>
                <template v-if="userBookingStatus === 'invited' && (user.isEventCoordinator() || user.isSessionTrainer(sessionTrainers))">
                    <div class="column is-narrow">
                        <component-button
                            class="btn--cancel"
                            :border="true"
                            :theme="'default'"
                            @click="performEmit('emit-cancel-invite', userSubscriptionId)"
                            :name="`session-show-people-table-item-actions-cancel-${userSubscriptionId}`"
                        >{{ $t('ebs.sessions.show.buttons.cancel') }}</component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            class="btn--resend"
                            :border="true"
                            :theme="'default'"
                            :name="`session-show-people-table-item-actions-resend-${userSubscriptionId}`"
                            @click="performEmit('emit-resend-invite', userSubscriptionId)"
                        >{{ $t('ebs.sessions.show.buttons.resend') }}</component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            class="btn--book"
                            :theme="'primary'"
                            :name="`session-show-people-table-item-actions-books-${userSubscriptionId}`"
                            @click="performEmit('emit-book-person', userSubscriptionId)"
                        >{{ $t('ebs.sessions.show.buttons.book') }}</component-button>
                    </div>
                </template>
                <template v-if="userBookingStatus === 'pending_acceptation' && (user.isEventCoordinator() || user.isSessionTrainer(sessionTrainers))">
                    <div class="column is-narrow">
                        <component-button
                            class="btn--decline"
                            :border="true"
                            :theme="'default'"
                            :name="`session-show-people-table-item-actions-decline-${userSubscriptionId}`"
                            @click="performEmit('emit-decline-booking', userSubscriptionId)"
                        >{{ $t('ebs.sessions.show.buttons.decline') }}</component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            class="btn--approve"
                            :border="true"
                            :theme="'primary'"
                            :name="`session-show-people-table-item-actions-approve-${userSubscriptionId}`"
                            @click="performEmit('emit-approve-booking', userSubscriptionId)"
                        >{{ $t('ebs.sessions.show.buttons.approve') }}</component-button>
                    </div>
                </template>
                <template v-if="(userBookingStatus === 'accepted' || userBookingStatus === 'booked') && (user.isEventCoordinator() || user.isSessionTrainer(sessionTrainers))">
                    <div class="column is-narrow">
                        <component-button
                            :border="true"
                            :theme="'default'"
                            :disabled="!sessionBookingInfoCancellationAllowed"
                            :name="`session-show-people-table-item-actions-cancelbooking-${userSubscriptionId}`"
                            @click="performEmit('emit-cancel-booking', userBookingId)"
                        >{{ $t('ebs.sessions.show.buttons.cancelBooking') }}</component-button>
                    </div>
                </template>
                <template v-if="userBookingStatus === 'cancelled'">
                    <div class="column is-narrow">
                        <component-button
                            class="btn--view-cancellation-reason"
                            :border="true"
                            :theme="'default'"
                            :name="`session-show-people-table-item-actions-viewcancellation-${userSubscriptionId}`"
                            @click="performEmit('emit-view-cancellation', userBookingId)"
                        >{{ $t('ebs.sessions.show.buttons.viewCancellation') }}</component-button>
                    </div>
                </template>
            </div>
        </td>
        <form-customform-notifypreview
            :submit-button-active="false"
            :cancel-button-text="$t('ebs.sessions.show.buttons.close')"
            :title="$t('ebs.sessions.show.title.previewBookingForm')"
            :disabled="true"
            ref="bookingformnotify"
            :items="userBookingForm"
        />
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import FormCustomformNotifypreview from '@/components/default/forms/FormCustomformNotifypreview'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'

export default {
  components: {
    ComponentButton,
    FormCustomformNotifypreview,
    ComponentStatus },
  name: 'session-show-people-table-item',
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      required: true
    }
  },
  computed: {
    userFirstName () {
      return this.item.firstName
    },
    userLastName () {
      return this.item.lastName
    },
    userEmail () {
      return this.item.email
    },
    userBookingForm () {
      return this.item.bookingForm || []
    },
    userBookingStatus () {
      return this.item.bookingStatus
    },
    userSubscriptionId () {
      return this.item.id
    },
    userBookingId () {
      return this.item.bookingId
    },
    sessionBookingInfoCancellationAllowed: function () {
      return this.$store.getters['getSessionBookingInfoCancellationAllowed']
    },
    sessionTrainers () {
      return this.$store.getters.getSessionTrainers
    }
  },
  methods: {
    emitViewBookingForm: function () {
      this.$refs.bookingformnotify.openNotify()
    },
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>
